<template lang="pug">
  div
    v-navigation-drawer(app v-model='drawer' clipped dark)
      FantasyNabvar(:menuList="menuList")
    HeaderNabvar(@menuEvent="drawer = !drawer" @logoutEvent="logout")
    v-content
      router-view(name="content")
    NotificationSnackbar
    v-footer(app)
      span © 2020
</template>

<script>

  import FantasyNabvar from "@/components/navbars/FantasyNabvar";
  import HeaderNabvar from "@/components/navbars/HeaderNabvar";
  import NotificationSnackbar from "@/components/snackbar/NotificationSnackbar";

  export default {
    name: 'Dashboard',
    components: {
      NotificationSnackbar,
      FantasyNabvar,
      HeaderNabvar,
    },
    data: () => ({
      drawer: false
    }),
    computed: {
      menuList(){
        return this.$t("components.fantasyNavbar");
      }
    },
    methods: {
      logout(){
        this.$store.dispatch('userLogout');
      },
    }
  };
</script>

<style>
  .fantasy-navbar__link .v-list-item__title {
      color:#FFFFFF;
  }
</style>
